<script setup lang="ts">
import type { CmsElementImageTextBlocks } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementImageTextBlocks;
}>();

const { data } = props.content;
</script>
<template>
  <section
    class="prose-p:text-sm prose-h3:mb-7 prose-h6:text-base prose-h6:mb-7 text-sm py-5"
    style=""
  >
    <div class="container px-0 xl:px-5">
      <div class="grid grid-cols-1">
        <div>
          <NuxtImg
            format="webp"
            loading="lazy"
            v-if="data.aboveTextImage"
            :src="data.aboveTextImage?.media.url"
            alt=""
            class="mb-8 h-20"
          />
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12 mb-7">
        <div>
          <div v-html="data.textLeft"></div>
        </div>
        <div>
          <div v-html="data.rightLeft"></div>
        </div>
      </div>
    </div>
  </section>
</template>
